import { render, staticRenderFns } from "./UnAuthorised.vue?vue&type=template&id=a7951480&"
import script from "./UnAuthorised.vue?vue&type=script&lang=js&"
export * from "./UnAuthorised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports